export default __webpack_public_path__ + "static/media/Fig3.4944c3db.jpg";